import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import Button from '../../../components/ui/Button';
import Card, { CardContent, CardHeader, CardTitle } from '../../../components/ui/Card';
import Skeleton from '../../../components/ui/Skeleton';
import { usePageTitle } from '../../../hooks/shared';
import { useMailerOrders } from '../hooks/useMailerOrders';

export default function MailerSuccessPage() {
  usePageTitle('Mailers Confirmed');

  const navigate = useNavigate();
  const [_searchParams] = useSearchParams();

  const { data: orders, isLoading } = useMailerOrders();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    if (orders && orders.data && orders.data.length > 0) {
      // Find the most recent order (should be the one we just paid for)
      const latestOrder = orders.data[0];
      if (latestOrder.status === 'paid') {
        setOrder(latestOrder);
      }
    }
  }, [orders]);

  if (isLoading) {
    return (
      <div className="max-w-2xl mx-auto px-4 py-8">
        <Skeleton className="h-12 w-full mb-4" />
        <Skeleton className="h-32 w-full" />
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto px-4 py-8">
      <Card className="border-2 border-green-600 bg-green-50">
        <CardHeader>
          <CardTitle className="text-green-800">✓ Your Mailers Are Confirmed!</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-neutral-700">
            Your mailer order has been processed successfully. You&apos;ll receive ballot guides at
            the times you selected.
          </p>

          {order && (
            <div className="bg-white p-4 rounded border border-neutral-200 space-y-2">
              <p>
                <span className="font-semibold">Election:</span> {order.election.name}
              </p>
              <p>
                <span className="font-semibold">Recipients:</span> {order.recipients.length}
              </p>
              <p>
                <span className="font-semibold">Total:</span> ${order.totalCharged}
              </p>
            </div>
          )}

          <div className="flex gap-3">
            <Button onClick={() => navigate('/deliveries')}>View Delivery History</Button>
            <Button variant="outline" onClick={() => navigate('/dashboard')}>
              Back to Dashboard
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
